import React from 'react'
import { postCommunity } from '../actions'
import Panel from 'common/components/Panel'
import CommunitiesForm from '../communitiesForm'

async function handleSubmit (values, form) {
  const { name, city, multilingual } = values
  const { setSubmitting, setErrors, setStatus, resetForm } = form
  try {
    await postCommunity({ name, city_id: city, multilingual })
    resetForm()
    setStatus({ success: true })
  } catch (e) {
    setStatus({ success: false })
    setErrors({ http: e.message })
  }
  setSubmitting(false)
}

const CreateCommunity = () => (
  <Panel title='Create Neighborhood'>
    <CommunitiesForm
      handleSubmit={handleSubmit}
      initialValues={{ name: '', city: 0, multilingual: false }}
    />
  </Panel>
)

export default CreateCommunity
